import { render } from "./AnnouncementCenterView.vue?vue&type=template&id=0d48f3fa&scoped=true&ts=true"
import script from "./AnnouncementCenterView.vue?vue&type=script&lang=ts"
export * from "./AnnouncementCenterView.vue?vue&type=script&lang=ts"

import "./AnnouncementCenterView.vue?vue&type=style&index=0&id=0d48f3fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d48f3fa"]])

export default __exports__